namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class VisualizerPage extends Serenity.PropertyPanel<GraphDataRequest, any> {

        protected getFormKey() { return GraphParameterForm.formKey; }
        protected form;
        protected store: GraphDataStore;

        private _ = go.GraphObject.make;
        private diagram: Diagram;
        private hostElm: HTMLElement;
        private rotatorFn: any;

        constructor(container: JQuery) {
            super(container);
            $('.s-visualizer-loader').show();
            window.setTimeout(() => {
                $('.s-visualizer-loader').hide()
            }, 4000);
     
            console.log(this.idPrefix);
            this.store = new GraphDataStore();
            this.form = new GraphParameterForm(this.idPrefix);

            this.form.NodeKey.element.getWidget(Matrix.FormatLookupEditor).changeSelect2(e => this.onNodeKeyChange());
            this.form.GraphKey.element.getWidget(Serenity.LookupEditor).changeSelect2(e => this.onGraphKeyChange());
            this.form.InstanceKey.element.getWidget(Serenity.LookupEditor).changeSelect2(e => this.onInstanceChange());
            this.form.ThemeKey.element.getWidget(Serenity.LookupEditor).changeSelect2(e => this.onThemeChange());

            // set filter change events
            this.form.ShowParents.element.getWidget(Serenity.LookupEditor).changeSelect2(e => this.onShowParentChange());
            this.form.ShowChildren.element.getWidget(Serenity.LookupEditor).changeSelect2(e => this.onShowChildrenChange());
            this.form.ShowSiblings.change(e => this.onShowSiblingChange());
            this.form.ShowAllrelated.change(e => this.onShowAllRelatedChange());

            this.form.GraphKey.set_value("Default");
            this.onGraphKeyChange();

            this.setFilterValues(true, ParentsFilter.AllAncestors, ChildrenFilter.AllDescendants, true);
            this.disableFilters();
        }

        private onShowParentChange() {
            const parentsFilter = Q.toId(this.form.ShowParents.value);
            if (parentsFilter === ParentsFilter.NoParents) {
                this.form.ShowSiblings.value = false;
            }

            if (parentsFilter !== ParentsFilter.AllAncestors) {
                this.form.ShowAllrelated.value = false;
            }

            if (this.diagram) {
                this.diagram.focusNode(this.getFilters());
            }
        }

        private onShowChildrenChange() {

            const showChildren = Q.toId(this.form.ShowChildren.value);
            if (showChildren !== ChildrenFilter.AllDescendants) {
                this.form.ShowAllrelated.value = false;
            }

            if (this.diagram) {
                this.diagram.focusNode(this.getFilters());
            }
        }

        private onShowSiblingChange() {
            const showSiblings = Q.toId(this.form.ShowSiblings.value);
            if (showSiblings) {
                const parentsFilter = Q.toId(this.form.ShowParents.value);
                if (parentsFilter === ParentsFilter.NoParents) {
                    this.form.ShowParents.value = ParentsFilter.ImmediateParents;
                }
            }

            if (!showSiblings) {
                this.form.ShowAllrelated.value = false;
            }

            if (this.diagram) {
                this.diagram.focusNode(this.getFilters());
            }
        }

        private onShowAllRelatedChange() {

            const showAllrelated = Q.toId(this.form.ShowAllrelated.value);
            if (showAllrelated) {
                this.setFilterValues(true, ParentsFilter.AllAncestors, ChildrenFilter.AllDescendants, true);
            }

            if (this.diagram) {
                this.diagram.focusNode(this.getFilters());
            }
        }

        private onNodeKeyChange() {
            if (!this.form.NodeKey.value) {
                this.setFilterValues(true, ParentsFilter.AllAncestors, ChildrenFilter.AllDescendants, true);
                this.disableFilters();
            } else {
                this.enableFilters();
            }

            if (this.diagram) {
                this.diagram.focusNode(this.getFilters());
            }
        }

        private onGraphKeyChange() {
            var graphKey = Q.toId(this.form.GraphKey.value);
            if (!graphKey) {
                $('#vz-title').html("Visualizer");
                this.form.InstanceKey.set_value(null);
                this.form.InstanceKey.set_readOnly(true);

                this.form.ThemeKey.set_value(null);
                this.form.ThemeKey.set_readOnly(true);

                this.onInstanceChange();
                return;
            }

            $('#vz-title').html("Visualizer : " + this.form.GraphKey.selectedItem.Description);

            const themesLookup = Q.getLookup("Visualizer.GraphTheme");
            const instancesLookup = Q.getLookup("Visualizer.GraphInstance");

            const themes: any[] = themesLookup.items;
            const instances = instancesLookup.items;
            let availableThemekeys: any[];

            let defaultInstance: any;

            // clear themes and instance drop downs
            this.form.ThemeKey.clearItems();
            this.form.InstanceKey.clearItems();

            // filter instances using selected graph key
            const filteredInstances = <GraphInstanceRow[]>instances.filter((inst) => graphKey === inst["GraphKey"])

            if (filteredInstances && filteredInstances.length > 0) {
                this.form.InstanceKey.set_readOnly(false);

                // build options
                filteredInstances.forEach((inst) => {
                    this.form.InstanceKey.addOption(inst[instancesLookup.idField], inst[instancesLookup.textField]);
                });

                // get default instance
                if (filteredInstances.some((t) => t[instancesLookup.textField] === "Default")) {
                    defaultInstance = filteredInstances.filter((t) => t[instancesLookup.textField] === "Default")[0];
                } else {
                    // set the default to firt item if there isnt a instance with name "default"
                    defaultInstance = filteredInstances[0];
                }

                // set default instance
                this.form.InstanceKey.set_value(defaultInstance[instancesLookup.idField]);

                // retreive theme key associated with instances
                availableThemekeys = filteredInstances.map((x) => x["ThemeKey"]).filter((v, i, a) => a.indexOf(v) === i);
            } else {
                this.form.InstanceKey.set_value(null);
                this.form.InstanceKey.set_readOnly(true);
            }

            if (availableThemekeys && availableThemekeys.length > 0) {

                const availableThemes = themes.filter(x => availableThemekeys.some(y => y === x[themesLookup.idField]));

                if (availableThemes && availableThemes.length > 0) {

                    this.form.ThemeKey.set_readOnly(false);

                    availableThemes.forEach((t) => {
                        this.form.ThemeKey.addOption(t[themesLookup.idField], t[themesLookup.textField]);
                    });

                    // set default theme retreived from default instance
                    this.form.ThemeKey.set_value(defaultInstance[themesLookup.idField]);

                } else {
                    this.form.ThemeKey.set_value(null);
                    this.form.ThemeKey.set_readOnly(true);
                }

            } else {
                this.form.ThemeKey.set_value(null);
                this.form.ThemeKey.set_readOnly(true);
            }


            const nodeLookup = Q.getLookup("Visualizer.GraphNode");
            const nodes: GraphNodeRow[] = nodeLookup.items;
            if (nodes && nodes.length > 0) {
                this.form.NodeKey.set_value(nodes[0].NodeId);
            }

            this.onInstanceChange();
            this.store.preload(filteredInstances);
        }

        private onInstanceChange() {

            const graphInstanceId = Q.toId(this.form.InstanceKey.value);
            const themeKey = Q.toId(this.form.ThemeKey.value);
            const graphKey = Q.toId(this.form.GraphKey.value);

            if (!graphInstanceId || !themeKey || !graphKey) {
                if (this.isDiagramAvailable()) {
                    this.diagram.destroyGraph();
                }

                return;
            }

            let request: GraphDataRequest = {
                GraphInstanceId: graphInstanceId,
                InstanceKey: this.form.InstanceKey.text,
                ThemeKey: themeKey,
                GraphKey: graphKey
            };

            this.store.getData(request, (data) => {

                if (!data) {
                    throw "No data found for selected instance.";
                }

                if (this.isDiagramAvailable()) {

                    const currSelectedNodeKey = this.diagram.getSelectedNode();

                    // check whether the previously selected node is available in the new instance's node
                    // if so set it in the node dropdown and passdown to graph filters
                    if (currSelectedNodeKey) {
                        const selectedNode = data.Nodes.filter(x => x.NodeKey === currSelectedNodeKey);
                        if (selectedNode && selectedNode.length > 0) {
                            this.form.NodeKey.value = selectedNode[0].NodeId;
                        }
                    }

                    this.refreshData(data, this.getFilters());
                } else {

                    this.buildGraph("diagramDiv", data, this.getFilters(), false);
                    //  this.rotateInstances();
                }

            });

        }

        private onThemeChange() {
            var graphKey = Q.toId(this.form.GraphKey.value);
            var themeKey = Q.toId(this.form.ThemeKey.value);

            this.form.InstanceKey.clearItems();

            const instancesLookup = Q.getLookup("Visualizer.GraphInstance");
            const instances = instancesLookup.items;
            let defaultInstance: any;

            // filter instances using selected graph key
            const filteredInstances = instances.filter((inst) => graphKey === inst["GraphKey"] && themeKey === inst["ThemeKey"]);
            if (filteredInstances && filteredInstances.length > 0) {
                this.form.InstanceKey.set_readOnly(false);

                // build options
                filteredInstances.forEach((inst) => {
                    this.form.InstanceKey.addOption(inst[instancesLookup.idField], inst[instancesLookup.textField]);
                });

                // get default instance
                if (filteredInstances.some((t) => t[instancesLookup.textField] === "Default")) {
                    defaultInstance = filteredInstances.filter((t) => t[instancesLookup.textField] === "Default")[0];
                } else {
                    // set the default to firt item if there isnt a instance with name "default"
                    defaultInstance = filteredInstances[0];
                }

                // set default instance
                this.form.InstanceKey.set_value(defaultInstance[instancesLookup.idField]);

            } else {
                this.form.InstanceKey.set_value(null);
                this.form.InstanceKey.set_readOnly(true);
            }

            this.onInstanceChange();
        }

        private setFilterValues(showAllrelated: boolean, showParents: ParentsFilter, showChildren: ChildrenFilter, showSiblings: boolean) {
            this.form.ShowAllrelated.value = showAllrelated;
            this.form.ShowParents.value = showParents;
            this.form.ShowChildren.value = showChildren;
            this.form.ShowSiblings.value = showSiblings;
        }

        private disableFilters() {
            Serenity.EditorUtils.setReadOnly(this.form.ShowParents, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShowChildren, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShowSiblings, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShowAllrelated, true);
        }

        private enableFilters() {
            Serenity.EditorUtils.setReadOnly(this.form.ShowParents, false);
            Serenity.EditorUtils.setReadOnly(this.form.ShowChildren, false);
            Serenity.EditorUtils.setReadOnly(this.form.ShowSiblings, false);
            Serenity.EditorUtils.setReadOnly(this.form.ShowAllrelated, false);
        }

        private getFilters() {

            let nodeKey = null;
            if (this.form.NodeKey.value) {
                const nodeLookup = Q.getLookup("Visualizer.GraphNode");
                const nodes: GraphNodeRow[] = nodeLookup.items;
                nodeKey = nodes.filter(x => x.NodeId === Q.toId(this.form.NodeKey.value))[0].NodeKey;
            }

            const filter: DiagramFilter = {
                NodeKey: nodeKey,
                ShowAllrelated: Q.toId(this.form.ShowAllrelated.value),
                ShowChildren: Q.toId(this.form.ShowChildren.value),
                ShowParents: Q.toId(this.form.ShowParents.value),
                ShowSiblings: this.form.ShowSiblings.value
            }

            return filter;
        }

        private resizeGraph() {
            if (this.isDiagramAvailable()) {
                const height = $('#VisualizerPage').height() - 110 + "px";
                this.diagram.setHeight(height);
            }
        }

        private isDiagramAvailable() {
            return this.diagram && !!this.diagram.div;
        }

        private refreshData(data: GraphDataResponse, filter: DiagramFilter) {
            this.setDiagramBackgroundColor(data.Theme.BackgroundColour);
            this.diagram.refreshData(data, filter);
        }

        private setDiagramBackgroundColor(color) {
            $("#diagramDiv").css("background-color", color);
            $("#overviewDiv").css("background-color", color);
        }

        private buildGraph(diagramDiv: string, data: GraphDataResponse, filter: DiagramFilter, showLocalView: boolean) {

            if (!diagramDiv) {
                throw "Diagram hosting div element name can't be empty.";
            }

            this.hostElm = document.getElementById(diagramDiv);
            if (!this.hostElm) {
                throw "Diagram hosting HTML element is not found.";
            }

            this.setDiagramBackgroundColor(data.Theme.BackgroundColour);

            this.diagram = new Diagram(diagramDiv, data, filter);

            this.resizeGraph();
            $(window).resize(() => { this.resizeGraph(); });

            this.diagram.OnFocusChange = (data: any) => {
                if (data && data[GraphNodeRow.Fields.NodeKey]) {
                    this.form.NodeKey.set_value(data[GraphNodeRow.Fields.NodeId]);
                    this.enableFilters();
                } else {
                    this.setFilterValues(true, ParentsFilter.AllAncestors, ChildrenFilter.AllDescendants, true);
                    this.disableFilters();
                }
            }
            $('.s-visualizer-loader').hide();

        }

        private rotateInstances() {

            //if (this.rotatorFn) {
            //    clearInterval(this.rotatorFn);
            //}

            this.rotatorFn = setInterval(() => {
                try {

                    if (!this.isDiagramAvailable()) {
                        return;
                    }

                    const items = this.form.InstanceKey.items;
                    const instanceKey = Q.toId(this.form.InstanceKey.value);
                    if (!instanceKey) {
                        return;
                    }

                    const currIdx = items.findIndex(x => x.id === instanceKey);
                    if (currIdx + 1 > items.length || currIdx < 0) {
                        return;
                    }

                    let nextIdx = 0;
                    if (items.length > currIdx + 1) {
                        nextIdx = currIdx + 1;
                    }

                    this.form.InstanceKey.value = items[nextIdx].id;
                    this.onInstanceChange();

                } catch (e) {

                }
            }, 1500);

            window.setTimeout(function () { $('.loader').hide(); }, 4000);
        }
    }
}